import React, { useCallback, useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../hooks";
import { DIIA_RESET, signDocs as diiaSign } from "../../actions/diia";
import { fetchDocument, signDocs } from "../../actions/pub";
import { DOCUMENT_VIEW_SUCCESS } from "../../actions/view";
import { SIGN_RESET } from "../../actions/sign";
import styles from "../../styles/View/View.module.css";
import ScaleSlider from "../ScaleSlider";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { FileSignPopup } from "../Popup/FileSignPopup";
import { SignPopup } from "../Popup/SignPopup";
//import MoreInfo from "../View/MoreInfo";
import { DiiaSignPopup } from "../Popup/DiiaSignPopup";
import Infobar from "../View/Infobar";
import DocsToolbarDevice from "../Docs/DocsToolbarDevice";
import { useMediaQuery } from "react-responsive";
import { SkeletonInfobar } from "../Loaders/SkeletonLoader";
import PdfViewer from "../View/PdfViewer";
import { useContainerDimensions } from "../../hooks";
import ZoomInMapIcon from "@mui/icons-material/ZoomInMap";
import { BtnWrapper } from "../../styles/Docs/DocsToolbar.styled";
import { PublicSign } from "../../styles/View/Infobar/Infobar.styled";


export default function View() {
  const params = useParams();
  const dispatch = useAppDispatch();
  // const navigate = useNavigate();
  const diia = useAppSelector((state) => state.diia);
  const doc = useAppSelector((state) => state.view);
  const sign = useAppSelector((state) => state.sign);
  const [showDiiaPopup, setShowDiiaPopup] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [showFilePopup, setShowFilePopup] = useState(false);

  const [showDetails, setShowDetails] = useState(false);
  const [scale, setScale] = useState(95);
  const [publicSignatures, setPublicSignatures] = useState([]);
  const handleSliderChange = (event: Event, newValue: number | number[]) => {
    setScale(newValue);
  };

  const signMethods =
    doc.signed || !doc.methods
      ? {}
      : doc.methods.reduce((memo, method) => {
          memo[method.alias] = true;
          return memo;
        }, {});

    const clickCloseButton = useCallback(() => {
      setShowDetails(false);
    }, [showDetails]);
      
    const closePopup = useCallback(() => {
      setShowPopup(false);
    });
  
  
    const closeFilePopup = useCallback(() => {
      setShowFilePopup(false);
    });
    

  const closeDiiaPopup = useCallback(() => {
    dispatch({ type: DIIA_RESET });
    setShowDiiaPopup(false);
  });

  const clickDiiaSignButton = useCallback(
    (e) => {
      e.preventDefault();
      dispatch({ type: SIGN_RESET });
      dispatch(diiaSign([params.id], "pub"));
      setShowDiiaPopup(true);
    },
    [params.id],
  );

  const clickSignButton = useCallback((e) => {
    e.preventDefault();
      dispatch({ type: SIGN_RESET });
    setShowPopup(true);
  }, []);


  const clickFileSignButton = useCallback((e) => {
    e.preventDefault();
      dispatch({ type: SIGN_RESET });
    setShowFilePopup(true);
  }, []);

  const submitForm = useCallback(
    (key) => {
      dispatch(signDocs([params.id], key, false));
    },
    [params.id],
  );

  const isDesktop = useMediaQuery({ minWidth: 992 });
  const isMobile = useMediaQuery({ maxWidth: 991 });
  const componentRef = useRef();
  const { width } = useContainerDimensions(componentRef);

  useEffect(() => {
    dispatch(fetchDocument(params.id));
  }, [params]);

  useEffect(() => {
    const items = JSON.parse(localStorage.getItem("publicSignatures"));
    if (items) {
      setPublicSignatures(items);
    }

    if (sign.state === "success") {
      sign.list.forEach((el) => {
        if (el.id === doc.id) {
          dispatch({
            type: DOCUMENT_VIEW_SUCCESS,
            payload: el,
          });
        }
      });
      setShowFilePopup(false);
      setShowPopup(false);
      closeDiiaPopup();
    }
  }, [sign]);

  return (
    <section
      className={isMobile ? styles.boxmobile : styles.wrapperIte}
    >
      {isMobile && showDetails && (
        <Infobar
          doc={doc}
          clickCloseButton={clickCloseButton}
          public={true}
          publicSign={publicSignatures.includes(doc.id)}
          signMethods={signMethods}
          sign={sign}
          heightBar={Object.keys(signMethods).length}
        />
      )}
      {!showDetails &&
      <div className={styles.left}>
        <div className={styles.toolsLine}>
        <ZoomInMapIcon />
          {doc.state === "success" && 
          <ScaleSlider
          style={{ width: "60%" }}
          max={isMobile ? 200 : 100}
          scale={scale}
          handleSliderChange={handleSliderChange}
          />
          }
          {isMobile && (
            <BtnWrapper $bgColor="var(--black)">
              <MoreVertIcon
                sx={{ color: "white" }}
                onClick={() => setShowDetails(true)}
              />
            </BtnWrapper>
          )}
        </div>
        <div 
          className={
            Object.keys(signMethods).length === 0 ? styles.pdfPub : (
              Object.keys(signMethods).length < 3 && !doc.error ? `${styles.pdfPub} ${styles.pdf_m}` : `${styles.pdfPub} ${styles.pdf_s}`
              )} 
        ref={componentRef}
        >
          <PdfViewer url={doc.url} width={width} scale={scale} />
        </div>
      </div>
      }

      {isDesktop && (
        <div className={styles.right} id="right">
          {doc.state === "loading" ? (
            <SkeletonInfobar />
          ) : (
            <>
              <Infobar
                public={true}
                doc={doc}
                sign={sign}
              />
              {(sign.state === "success" || publicSignatures.includes(doc.id)) ? (
                <PublicSign>
                  <span>Документ підписано</span>
                </PublicSign>
              ) : (
                <DocsToolbarDevice
                  clickDiiaSignButton={
                    signMethods.diia
                      ? clickDiiaSignButton
                      : null
                  }
                  clickSignButton={
                    signMethods.gryada ? clickSignButton : null
                  }
                  clickFileSignButton={
                    signMethods.file ? clickFileSignButton : null
                  }
                  public={true}
                  // publicSign={publicSignatures.includes(doc.id)}
                  signMethods={signMethods}
                  sign={sign}
                  doc={doc}
                /> 
              )}
            </>
          )}
        </div>
      )}
      {isMobile && (
        doc.state === "loading" ? 
        null : (
          (sign.state === "success" || publicSignatures.includes(doc.id)) ? (
            <PublicSign>
              <span>Документ підписано</span>
            </PublicSign>
          ) : (
          <DocsToolbarDevice
            hideDownloadFilesBtn={true}
            showDetails={showDetails}
            clickDiiaSignButton={
              doc.state !== "failure" && !publicSignatures.includes(doc.id)
                ? clickDiiaSignButton
                : null
            }
            clickSignButton={
              signMethods.gryada ? clickSignButton : null
            }
            clickFileSignButton={
              signMethods.file ? clickFileSignButton : null
            }
            public={true}
            publicSign={publicSignatures.includes(doc.id)}
            signMethods={signMethods}
            sign={sign}
            doc={doc}
          />
          )
        )
      )}

      {showDiiaPopup ? (
        <DiiaSignPopup clickCloseButton={closeDiiaPopup} diia={diia} />
      ) : null}
      {showPopup ? (
        <SignPopup
          clickCloseButton={closePopup}
          onSubmit={submitForm}
          sign={sign}
        />
      ) : null}
      {showFilePopup ? (
        <FileSignPopup
          clickCloseButton={closeFilePopup}
          onSubmit={submitForm}
          sign={sign}
        />
      ) : null}
    </section>
  );
}
